import { personalInfo } from "../data/personalInfo";
import { personalInterests } from "../data/personalInterests";
import { intentMap } from "./maps/intentMap";
import {
    ABOUT_RESPONSES,
    SOCIAL_RESPONSES,
    EXPERIENCE_RESPONSES,
    SKILLS_RESPONSES,
    PROJECTS_RESPONSES,
    PROGRAMMING_LANGUAGES_RESPONSES,
    ANIME_RESPONSES,
    MANGA_RESPONSES,
    HOBBIES_RESPONSES,
    HOME_PROJECTS_RESPONSES,
    OPEN_SOURCE_RESPONSES,
    COMMUNITY_RESPONSES,
    CERTIFICATIONS_RESPONSES,
    HOME_OFFICE_RESPONSES,
    BLOCKCHAIN_RESPONSES,
    KIDS_RESPONSES,
    LOCATION_RESPONSES,
    CODING_PHILOSOPHY,
    DAILY_LIFE_RESPONSES,
    generateSpokenLanguagesResponses,
    generateMusicResponses,
    generateFoodResponses,
    generateGamingResponses,
    generateEducationResponses,
    generateWorkspaceResponses,
    generateBeveragesResponses,
    generateToolsResponses,
    generateFrameworksResponses,
    movieQuotes,
    DIGITAL_ART_RESPONSES
} from './maps/responses';

function findIntent(text) {
    const normalizedText = text.toLowerCase().replace(/[']/g, '').trim();

    for (const [intent, phrases] of Object.entries(intentMap)) {
        if (phrases.some(phrase => normalizedText === phrase.toLowerCase())) {
            return intent;
        }
    }

    for (const [intent, phrases] of Object.entries(intentMap)) {
        if (phrases.some(phrase => normalizedText.includes(phrase.toLowerCase()))) {
            return intent;
        }
    }

    const words = normalizedText.split(/\s+/);
    for (const [intent, phrases] of Object.entries(intentMap)) {
        for (const word of words) {
            if (phrases.some(phrase => phrase.toLowerCase() === word)) {
                return intent;
            }
        }
    }

    return null;
}

const randomHumanizedResponse = (arr) =>
    arr[Math.floor(Math.random() * arr.length)];


export const generateRawResponse = (question) => {
    const intent = findIntent(question);

    if (!intent) {
        return {
            text: randomHumanizedResponse(movieQuotes)
        };
    }

    switch (intent) {
        case "intro":
        case "about":
            return {
                text: randomHumanizedResponse(ABOUT_RESPONSES),
                component: "About"
            };

        case "social":
        case "connect":
        case "contact":
            return {
                text: randomHumanizedResponse(SOCIAL_RESPONSES),
                component: "Socials"
            };

        case "experience":
        case "workHistory":
            return {
                text: randomHumanizedResponse(EXPERIENCE_RESPONSES),
                component: "Timeline"
            };

        case "skills":
            return {
                text: randomHumanizedResponse(SKILLS_RESPONSES),
                component: "Skills"
            };

        case "codingPhilosophy":
            return {
                text: randomHumanizedResponse(CODING_PHILOSOPHY)
            };

        case "projects":
            return {
                text: randomHumanizedResponse(PROJECTS_RESPONSES),
                component: "Projects"
            };

        case "programmingLanguages":
            return {
                text: randomHumanizedResponse(PROGRAMMING_LANGUAGES_RESPONSES)
            };

        case "anime":
            return {
                text: randomHumanizedResponse(ANIME_RESPONSES),
                component: "AnimeList"
            };

        case "manga":
            return {
                text: randomHumanizedResponse(MANGA_RESPONSES),
                component: "MangaList"
            };

        case "digitalArt":
            return {
                text: randomHumanizedResponse(DIGITAL_ART_RESPONSES),
                component: "ArtStation"
            };

        case "hobbies":
            return {
                text: randomHumanizedResponse(HOBBIES_RESPONSES),
                component: "Hobbies"
            };

        case "homeProjects":
            return randomHumanizedResponse(HOME_PROJECTS_RESPONSES);

        case "openSource":
            return randomHumanizedResponse(OPEN_SOURCE_RESPONSES);

        case "community":
            return randomHumanizedResponse(COMMUNITY_RESPONSES);

        case "certifications":
            return randomHumanizedResponse(CERTIFICATIONS_RESPONSES);

        case "homeOffice":
            return randomHumanizedResponse(HOME_OFFICE_RESPONSES);

        case "blockchain":
            return randomHumanizedResponse(BLOCKCHAIN_RESPONSES);

        case "kids":
            return randomHumanizedResponse(KIDS_RESPONSES);

        case "location":
            return randomHumanizedResponse(LOCATION_RESPONSES);

        case "dailyLife":
            return randomHumanizedResponse(DAILY_LIFE_RESPONSES);

        case "spokenLanguages":
            {
                const langs = personalInfo.languages.map((l) => l.name)?.join(", ");
                return randomHumanizedResponse(generateSpokenLanguagesResponses(langs));
            }

        case "music":
            {
                const artists = personalInterests.music.artists?.join(", ");
                return randomHumanizedResponse(generateMusicResponses(artists, personalInterests.music.favorite));
            }

        case "food":
            {
                const foodList = personalInterests.food.favorites?.join(", ");
                return randomHumanizedResponse(generateFoodResponses(foodList));
            }

        case "gaming":
            {
                const platforms = personalInterests.gaming.platforms?.join(", ");
                const arcades = personalInterests.gaming.arcadeFavorites?.join(", ");
                return randomHumanizedResponse(generateGamingResponses(platforms, arcades));
            }

        case "education":
            {
                const edu = personalInfo.education
                    .map((e) => `${e.school} in ${e.field}`)
                    .join(" | ");
                return randomHumanizedResponse(generateEducationResponses(edu));
            }

        case "workspace":
            return randomHumanizedResponse(generateWorkspaceResponses(
                personalInterests.workStyle.focus,
                personalInterests.workStyle.approach
            ));

        case "beverages":
            {
                const coffees = personalInterests.workStyle.beverages.coffee?.join(", ");
                const teas = personalInterests.workStyle.beverages.tea?.join(", ");
                return randomHumanizedResponse(generateBeveragesResponses(coffees, teas));
            }

        case "tools":
            {
                const editor = personalInterests.techPreferences.editor;
                const tools = personalInterests.techPreferences.tools.join(", ");
                const packageManager = personalInterests.techPreferences.packageManager;
                return randomHumanizedResponse(generateToolsResponses(editor, tools, packageManager));
            }

        case "frameworks":
            {
                const frameworks = personalInterests.techPreferences.frameworks.join("and ");
                return randomHumanizedResponse(generateFrameworksResponses(frameworks));
            }

        default:
            return {
                text: randomHumanizedResponse(movieQuotes)
            };
    }
};
